import { useState } from "react";
import { Reveal } from "@/components/Reveal";
import { Lightbox } from "@/components/Lightbox";
import { motion } from "framer-motion";
import { GALLERY } from "@/constants/content";
import { ImageDisclaimer } from "@/components/ImageDisclaimer";

export const Gallery = () => {
  const [index, setIndex] = useState(null);
  return (
    <section id="gallery" className="cp-section cp-section--navy" data-testid="gallery-section">
      <div className="cp-container">
        <Reveal className="cp-section-head">
          <span className="cp-eyebrow gold">Image Gallery</span>
          <h2 className="cp-h2 light">Central Plaza, In Frame</h2>
        </Reveal>

        <div className="cp-gallery-grid">
          {GALLERY.map((g, i) => (
            <motion.button
              key={g.src}
              className="cp-gallery-item"
              onClick={() => setIndex(i)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.07 }}
              whileHover={{ y: -6 }}
              data-testid={`gallery-item-${i}`}
            >
              <img src={g.src} alt={g.alt} loading="lazy" />
              <span className="cp-gallery-caption">{g.alt}</span>
            </motion.button>
          ))}
        </div>
        <ImageDisclaimer light className="cp-gallery-disclaimer" />
      </div>

      <Lightbox
        images={GALLERY}
        index={index}
        onClose={() => setIndex(null)}
        onPrev={() => setIndex((index - 1 + GALLERY.length) % GALLERY.length)}
        onNext={() => setIndex((index + 1) % GALLERY.length)}
      />
    </section>
  );
};
